import './commons/global-setup'
import './scss/common/style.scss'

async function initApplication() {
  try {
    const [{ MicroAppBootstrap }, { microAppsConfig }, trackingManagerModule] = await Promise.all([
      import('./core/MicroLoader').catch((err) => {
        console.error('[Main] Failed to load MicroLoader:', err)
        throw err
      }),
      import('./config/microApps.config').catch((err) => {
        console.error('[Main] Failed to load microApps.config:', err)
        throw err
      }),
      import('./apps/telemetry').catch((err) => {
        console.warn('[Main] Failed to load telemetry:', err)
        return { default: { initTelemetryTracker: () => {} } }
      })
    ])

    const trackingManager = trackingManagerModule.default

    const bootstrap = new MicroAppBootstrap(microAppsConfig)
    bootstrap.loadConfig(window.microsDatas || {})
    await bootstrap.bootstrap()

    const failedAppsCount = bootstrap.failedApps.size
    if (failedAppsCount > 0) {
      console.warn(
        `[Bootstrap] ${failedAppsCount} app(s) failed to load, but the application is running:`,
        Array.from(bootstrap.failedApps)
      )
    }

    if (window.__failedChunks && window.__failedChunks.size > 0) {
      console.warn(
        `[Bootstrap] ${window.__failedChunks.size} chunk(s) failed to load:`,
        Array.from(window.__failedChunks)
      )
    }

    if (typeof window !== 'undefined') {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(() => {
          trackingManager.initTelemetryTracker()
        })
      } else {
        setTimeout(() => {
          trackingManager.initTelemetryTracker()
        }, 0)
      }
    }
    const mainContentLink = document.getElementById('the-main-content')
    if (mainContentLink?.tagName === 'A' && mainContentLink.textContent.trim() === '') {
      const contentBody = mainContentLink.closest('.content-body')
      if (contentBody && !contentBody.id) {
        contentBody.id = 'the-main-content'
        contentBody.removeAttribute('role')
        mainContentLink.remove()
      }
    }
  } catch (error) {
    console.error('[Bootstrap] Critical error during initialization:', error)
    console.warn('[Bootstrap] Some core features may not work, but attempting to continue...')
  }
}

initApplication()
